import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SpreadImport } from "./SpreadSheetViewComponent";

const SpreadImportWrapper = (props: any) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(
    new URLSearchParams(location.search).get("activeTab")
  );

  // Update active tab when location changes
  useEffect(() => {
    setActiveTab(new URLSearchParams(location.search).get("activeTab"));
  }, [location]);

  // Function to update the active tab in the URL
  const updateActiveTab = (newTab: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("activeTab", newTab);
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  return (
    <SpreadImport
      {...props}
      match={{ params }}
      location={location}
      navigate={navigate}
      activeTab={activeTab}
      updateActiveTab={updateActiveTab}
      ref={props.reference}
    />
  );
};

export default SpreadImportWrapper;
